import React from 'react'

const SvgDocsDownload = props => (
  <svg viewBox='0 0 14 16' {...props}>
    <path d='M8 7h4l-5 5-5-5h4V0h2v7zm6 7v2H0v-2h14z' fill='#fd5c1f' />
  </svg>
)

export default SvgDocsDownload
